import React from "react";
import styled from "styled-components";
import { mixinSkins } from "../../../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { CTA } from "../../../../../components/CTA";
import { BetaMasthead } from "../../../components/BetaMasthead";
import { z } from "zod";
import { BetaRegistrationMastheadBladeSchema, } from "../../../schemas/BetaRegistrationMasthead";
import { useBetaHubRouter } from "../../../functional/hooks/useBetaHubRouter";
import { useActionReducer } from "../../../../../context/ActionProvider";
import { BetaLoader } from "../../../components/BetaLoader";
export const BetaSuccessMastheadContractSchema = BetaRegistrationMastheadBladeSchema.extend({
    type: z.literal("betaSuccessMasthead"),
});
const _BetaSuccessMasthead = ({ header, className, backdrop, gameIcon, campaignID, buttons = [], ...bladeProps }) => {
    const { isLoading, isAllowedRoute, isFullScreen } = useBetaHubRouter({ campaignID });
    const { dispatchAction } = useActionReducer();
    return (React.createElement(BetaLoader, { isLoading: isLoading, isAllowedRoute: isAllowedRoute, palette: "palette3" },
        React.createElement(BetaMasthead, { header: header, backdrop: backdrop, gameIcon: gameIcon, isFullHeight: isFullScreen, className: className, ...bladeProps },
            React.createElement("div", { className: "ctaContainer" }, buttons &&
                buttons.map((button, index) => (React.createElement(CTA, { key: index, variant: index === 0 ? "primary" : "secondary", className: "icon-tab-header-link-cta", onClick: () => dispatchAction(button?.action) }, button.title)))))));
};
export const BetaSuccessMasthead = styled(_BetaSuccessMasthead) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=BetaSuccessMasthead.js.map